import SelectBase from 'react-select'
import styled, { css } from 'styled-components'

import { spaces } from '@/config/global-parameters'

export interface ITitleOption {
  label: string
  value: string
}

export const TitleCss = css`
  text-align: center;
  font-weight: 300;
  line-height: 32px;
  font-size: 32px;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    font-size: ${spaces.m};
  }
`

const SelectTitle = styled(SelectBase<ITitleOption>)`
  ${TitleCss}
`

export const Title = styled.h1<{ bold?: boolean }>`
  ${TitleCss}
  ${(props) => props.bold && 'font-weight: 400;'}
  margin: 0;
`

export default SelectTitle
